import Component from '@glimmer/component';

import { t } from 'ember-intl';

import Button from 'umg-ember-backend/components/ui/button';
import clipboard from 'umg-ember-backend/modifiers/clipboard';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export default class AssetToolsAssetInformationComponent extends Component {
  // Getter and setter
  get assetInformation() {
    const headline = this.args.asset.headline;
    const artist = this.args.asset.artists[0]?.screenname ?? '-';
    const duration = this.args.asset.duration ?? '-';

    return `Title: ${headline}\r\nArtist: ${artist} \r\nDuration: ${duration}`;
  }

  // Template
  <template>
    <div class={{(bem)}} ...attributes>
      <label for='asset-information' class={{bem 'label'}}>
        {{t 'asset_tools.asset_information.label'}}
      </label>

      <textarea
        class={{bem 'textarea'}}
        id='asset-information'
        rows='3'
        readonly
      >
        {{this.assetInformation}}
      </textarea>

      <Button
        @label={{t 'asset_tools.asset_information.copy'}}
        {{clipboard
          text=this.assetInformation
          onSuccess=@copySuccess
          onError=@copyError
        }}
      />
    </div>
  </template>
}
